import React from 'react'

function Footer() {
  return (
    <div className="relative z-20 text-primary flex justify-between items-center p-4 my-20 lg:px-16 lg:py-6 text-sm lg:text-lg"></div>
  )
}

export default Footer